<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 系统配置
                </el-breadcrumb-item>
                <el-breadcrumb-item>企微配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" > 
                <span class="label-span">
                    <label class="label">监控词</label> 
                    <el-input v-model.trim="query.info" placeholder="监控词" class="handle-input mr10"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">消息级别</label> 
                    <el-select v-model.trim="query.level" clearable placeholder="请选择结算类型" class="handle-select mr15"  >
                        <el-option label="全部" value="" />
                        <el-option label="通知" value="1" />
                        <el-option label="预警" value="2" /> 
                        <el-option label="异常" value="3" />      
                    </el-select>   
                </span> 
                <el-button type="success" icon="el-icon-search"    @click="handleSearch">搜索</el-button>
                <el-button type="warning" icon="el-icon-refresh"    @click="refreshSearch">重置</el-button> 
                <el-button type="primary" icon="el-icon-lx-roundadd" class="mr10"   @click="addBind" >新增配置</el-button> 
                
            </el-card>
            <el-card shadow="hover"  class="containCard" > 
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"   >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="id" min-width="50" align="left" label="ID"></el-table-column>
                <el-table-column prop="info" min-width="190" align="left" label="监控词"></el-table-column> 
                <el-table-column prop="level" min-width="80" align="center" label="消息级别">
                    <template slot-scope="scope">
                         <el-tag :type="scope.row.level==1?'primary':scope.row.level==2?'warning':scope.row.level==3?'danger':'info'" >{{scope.row.level==1?"通知":scope.row.level==2?"预警":scope.row.level==3?"异常":""}}</el-tag>
                    </template>  
                </el-table-column>  
                <el-table-column prop="type" min-width="100" align="center" label="触发机制">
                    <template slot-scope="scope">
                        {{scope.row.type==1?"数量触发":scope.row.type==2?"比例触发":scope.row.type==3?"数量和比例":scope.row.type==4?"数量或比例":""}} 
                    </template>  
                </el-table-column>  
                <el-table-column prop="num" min-width="80" align="left" label="触发数量"></el-table-column> 
                <el-table-column prop="level" min-width="80" align="center" label="触发比例">
                    <template slot-scope="scope">
                        {{scope.row.pre}} <span v-if="scope.row.pre">%</span>
                    </template>  
                </el-table-column>  
                <el-table-column prop="channelStatus" min-width="80" align="center" label="监控状态">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.status=='1'?'开启':'关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip> 
                    </template> 
                </el-table-column>  
                <el-table-column prop="createTime" min-width="160" align="left"  label="触发时间"> </el-table-column>  
                <el-table-column label="操作" min-width="150" align="center" fixed="right">
                    <template slot-scope="scope">   
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  prev, pager, next" 
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange" 
                ></el-pagination>
            </div>
        </el-card> 
        <!-- 新建代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增配置" :modal-append-to-body='false' :visible.sync="addPlusVisible"  width="520px">
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item label="消息级别" >
                    <el-radio-group  v-model.trim="form1.level" >
                        <el-radio-button label="1">通知</el-radio-button> 
                        <el-radio-button label="2">预警</el-radio-button>
                        <el-radio-button label="3">异常</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>  
                <el-form-item label="监控词" >
                    <el-input  v-model="form1.info" placeholder="必填" ></el-input>   
                </el-form-item>  
                <el-form-item label="触发数量" >
                    <el-input  v-model.trim="form1.num" oninput="value=value.replace(/[^\d]/g,'')" style="width:165px;" placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="触发比例" >
                    <el-input  v-model.trim="form1.pre" oninput="value=value.replace(/[^\d]/g,'')" style="width:165px;" placeholder="必填"></el-input>   %
                </el-form-item>  
                <el-form-item label="触发机制" >
                    <el-radio-group  v-model.trim="form1.type" >
                        <el-radio-button label="1">数量触发</el-radio-button> 
                        <el-radio-button label="2">比例触发</el-radio-button>
                        <el-radio-button label="3">数量和比例</el-radio-button> 
                        <el-radio-button label="4">数量或比例</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>   
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>
  

     
        <!-- 编辑代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑配置" :modal-append-to-body='false' :visible.sync="editPlusVisible"  width="520px">
            <el-form ref="form" :model="form3" label-width="90px">
                <el-form-item label="消息级别" >
                    <el-radio-group  v-model.trim="form3.level" >
                        <el-radio-button label="1">通知</el-radio-button> 
                        <el-radio-button label="2">预警</el-radio-button>
                        <el-radio-button label="3">异常</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>  
                <el-form-item label="监控词" >
                    <el-input  v-model="form3.info" placeholder="必填" ></el-input>   
                </el-form-item>  
                <el-form-item label="触发数量" >
                    <el-input  v-model.trim="form3.num" oninput="value=value.replace(/[^\d]/g,'')" style="width:165px;" placeholder="必填"></el-input>   
                </el-form-item>  
                <el-form-item label="触发比例" >
                    <el-input  v-model.trim="form3.pre" oninput="value=value.replace(/[^\d]/g,'')" style="width:165px;" placeholder="必填"></el-input>   %
                </el-form-item>  
                <el-form-item label="触发机制" >
                    <el-radio-group  v-model.trim="form3.type" >
                        <el-radio-button label="1">数量触发</el-radio-button> 
                        <el-radio-button label="2">比例触发</el-radio-button>
                        <el-radio-button label="3">数量和比例</el-radio-button> 
                        <el-radio-button label="4">数量或比例</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>   
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="editPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
         
 
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus,changeSure} from '../../api/wxWorkConfig';  
export default {

    data() {
        return {  
            Timeout:'',
            mid:'', 
            secret:'',
            stationId:'', 
            loginName:'',
            activeNames:1,
            select:{ option:'',  }, 
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                level:'2',
                type:'4', 
            },
            form2: {   },
            form3: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
        this.getSelect();
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'info');  
            this.$set(this.query, 'level');   
        }, 
     
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        },

        //获取下拉框数据
        getSelect(){   
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.select.option = res.data; 
                }
            });
        }, 

        //查询
        getData(){  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
        
        // 新增渠道
        addBind() {
            this.addPlusVisible = true; 
        },
        //保存新增
        saveForm() {   
            if( !this.form1.info ){
                this.$message.error("请填写监控词");
                return;
            }
            if( this.form1.type!=2 && !this.form1.num ){
                this.$message.error("请填写触发数量");
                return;
            } 
            if( this.form1.type!=1 && !this.form1.pre ){
                this.$message.error("请填写触发比例");
                return;
            } 
             
            saveForm(this.form1).then(res => {
                if(res.code=='200'){
                    this.addVisible = false;
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {  
            this.editPlusVisible = true;
            this.form3 = row;   
        },

         
        // 保存更改
        saveEdit() {   
            if( !this.form3.info ){
                this.$message.error("请填写监控词");
                return;
            }
            if( this.form3.type!=2 && !this.form3.num ){
                this.$message.error("请填写触发数量");
                return;
            } 
            if( this.form3.type!=1 && !this.form3.pre ){
                this.$message.error("请填写触发比例");
                return;
            }  
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.editPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            changeStatus(row).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message);
                    if(row.status=='1'){
                        row.status = '0';
                    }else{
                        row.status = '1';
                    } 
                } 
            }); 
        },
        // q启用、禁用--改变状态
        handleSure(index, row) {  
            changeSure(row).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{ 
                    this.$message.error(res.message);
                    if(row.sure=='1'){
                        row.sure = '0';
                    }else{
                        row.sure = '1';
                    } 
                } 
            }); 
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('去顶要删除该商户吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
